import { useMutation } from '@tanstack/react-query'
import { selectLuckyDraw } from '../../../service/point'

export const useLuckyDraw = () => {
  return useMutation({
    mutationKey: ['select-lucky-draw'],
    mutationFn: selectLuckyDraw,
  })
}
